export default {
    path : "warehouse-item-recycled",
    name : "warehouse-item-recycled",
    meta : {
        title : "关注项目"
    },
    component: () => import('@/pages/warehouse/recycled/Index'),
    redirect: {
        name : "warehouse-item-recycled-whole"
    },
    children: [
        {
            path: 'all',
            name: 'warehouse-item-recycled-whole',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'warehouse-item-recycled-recent',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'warehouse-item-recycled-atme',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'warehouse-item-recycled-meat',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'warehouse-item-recycled-reply',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'warehouse-item-recycled-search',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/warehouse/recycleditem/index.js